import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'
import menuLink from '../../Valentines.pdf'
import menuImage from '../../assets/images/menuVday.png'

export default function Valentines(){
  return (
    <div className="pageStyles vdayPage">
      <Helmet>
        <title>Valentine's Weekend at Villaggio</title>
        <meta name="description" content="Your Valentine will feel the love when you celebrate with Villaggio Grille. Enjoy our special, Valentine's Day menu!" />
      </Helmet>

      <div className="simpleBanner">
        <div className="bannerWrap med3Def">
          <h1><span>♥️ </span>Be Our Valentine ♥️</h1>
          <h4>February 14th &amp; 15th</h4>
          <p className="res">Reservations Recommended: <br/><span><PhoneLink /></span></p>
        </div>
      </div>

      <div className="page-content textCenter">
        <div className="sectionWrap insideNrw food-menus no-padding">
          <p className="instr">Click image below to view/download</p>
          <a href={menuLink} target="_blank" rel="noopener noreferrer" className="menu-item menuImg">
            <img src={menuImage} alt="Villaggio Lunch Menu, Orange Beach, AL restaurant" className="bshadow" />
          </a>
        </div>
      </div>
    </div>
  )
}
